exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".frequency-distribution-widget {\n  display: flex;\n  height: 100%;\n  padding: 0 8px;\n}\n", ""]);

// exports
